<template>
  <header class="hp-hero">
    <div class="hp-hero__bg" aria-hidden="true"></div>
    <div class="container hp-hero__container">
      <div class="hp-hero__content hp-animate">
        <p class="hp-hero__eyebrow">India's video profile job platform</p>
        <h1 class="hp-hero__title">
          Find jobs.<br />
          Stand out with your <span class="hp-hero__accent">#visume</span>
        </h1>
        <p class="hp-hero__subtitle hp-hide-mobile">
          Search thousands of fresher, IT, and government openings — then impress recruiters with your 2-minute video profile.
        </p>
        <p class="hp-hero__subtitle hp-show-mobile">
          Fresher, IT &amp; government openings — stand out with your video profile.
        </p>
        <div class="hp-hero__actions">
          <a href="/jobseeker/register" class="hp-btn hp-btn--outline">Create video profile</a>
        </div>
      </div>

      <div class="hp-hero__search-card hp-hide-mobile hp-animate hp-animate--delay-1">
        <HomeSearchBar
          :filter.sync="localFilter"
          :course-options="courseOptions"
          :location-options="locationOptions"
          variant="hero"
          id-prefix="hp-hero"
          @search="$emit('search')"
        />
      </div>

      <HomeTrustStrip class="hp-hero__trust hp-animate hp-animate--delay-2" />
    </div>
  </header>
</template>

<script>
import HomeSearchBar from '@/components/home/HomeSearchBar.vue';
import HomeTrustStrip from '@/components/home/HomeTrustStrip.vue';

export default {
  name: 'HomeHero',
  components: { HomeSearchBar, HomeTrustStrip },
  props: {
    filter: { type: Object, required: true },
    courseOptions: { type: Array, default: () => [] },
    locationOptions: { type: Array, default: () => [] },
  },
  computed: {
    localFilter: {
      get() { return this.filter; },
      set(val) { this.$emit('update:filter', val); },
    },
  },
};
</script>
